import * as Moment from "moment";

export class WesternYearConverter {
   getYear(moment: Moment.Moment, length: number): string {
    if (length <= 0) {
      return "";
    }
    if (!moment) {
      return "".padStart(length, " ");
    }
    const value = (length > 2)
      ? moment.year()
      : moment.year() % 100;  // 年の末尾の数字2桁
    
    return value.toString().padStart(length, "0");
  }
}
